import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
export var useColumnName = function (subCategoryId) {
    var label = "";
    switch (subCategoryId) {
        case ESubProductIds.NCD:
            label = "Product Name";
            break;
        case ESubProductIds.StructuredProducts:
            label = "Scheme Name";
            break;
        case ESubProductIds.Bonds:
            label = "Product Name";
            break;
        case ESubProductIds.UnlistedShares:
            label = "Scheme Name";
            break;
        default:
            label = "";
    }
    return label;
};
